<template>

    <div>
        <v-card flat color="transparent" :class="getFontClasses(backgroundColor) + ' body-1'">
            {{questionText}}
        </v-card>

        <v-slide-x-transition>
            <div class="caption red--text error-box" v-if="errorMessages && errorMessages.length > 0">
                {{errorMessages[0]}}
            </div>
        </v-slide-x-transition>
    </div>

</template>

<script>

    import colorMixin from "./colorMixin";

    export default {

        name: "QuestionHeader",

        mixins: [colorMixin],

        props: {
            questionText: {
                type: String,
                required: true,
            },
            errorMessages: {
                type: Array | null,
                required: false,
            },
            backgroundColor: {
                type: String,
                required: true,
            }
        },
    }
</script>

<style scoped>

    .error-box {
        padding-top: 5px;
        height: 25px;
    }
</style>